/* ============================================================
   remixes
   ============================================================ */

export const remixes = {
    id: "7",
    type: "playlist",
    featured: true,
    title: "Remixes",
    link: "remixes",
    playlistBg: "rgb(249, 255, 168)",
    imgUrl: "../image/disco/mdlr.jpg", ///image/set/remixes.jpg
    hoverColor: "rgb(249, 255, 168)",
    artist: "alibhtty",
    artistImgUrl: "../image/djs/alibhtty/alibhtty.jpg",
    artistBio: "All Remixes",
    artistDownload: "Descargar",
    bannerUno: "",
    downloadData: [],
    playlistData: [
      {
        id: "1",
        songName: "Que viene el Álbum (MDLR)",
        songimg: "../image/disco/mdlr.jpg",
        songArtist: "Morad, Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/scl/fi/v972aknctq9kzkbyidgnp/Que-viene-el-lbum-MDLR-Morad-alibhtty-remix.mp3?rlkey=30fz6tinl9krmjemapp4ahc43&dl=1",
        trackTime: "6:02",
        genre: "techno",
        genres: ["urban", "pop"],
      },
      {
        id: "2",
        songName: "Calling",
        songimg: "../image/disco/calling.jpg",
        songArtist: "Jalen, Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/s/e4y32w713qjcekj/1-01%20Calling%202%20%28feat.%20Ali%20Bhtty%29.m4a",
        trackTime: "4:12",
        genre: "bass",
        genres: ["trap", "urban"],
      },
      {
        id: "3",
        songName: "Turn On The Lights",
        songimg: "../image/disco/turn-on.jpg",
        songArtist: "Fred Again, Knock2",
        artistLink: "knock2",
        link: "https://dl.dropbox.com/s/mje86h2ubhxk6e0/Fred%20again%20-%20Turn%20On%20The%20Lights%20again%20%28Knock2%20Remix%29.mp3?dl=1",
        trackTime: "3:27"
      },
      {
        id: "4",
        songName: "Embrace",
        songimg: "../image/disco/mith-1x1.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/s/vy8kcd79brun966/Mith%20-%20Ali%20Bhtty.m4a",
        trackTime: "2:48",
        promo: "../image/disco/mith-1x1.jpg",
        promoCategory: 2
      },
      {
        id: "5",
        songName: "Suspense Radio",
        songimg: "../image/radio/ripchord.jpg",
        songArtist: "Karan!",
        artistLink: "karan!",
        link: "https://dl.dropbox.com/scl/fi/8iyttdcag6xw5inx658gg/Ripchord-Subtle-Radio.mp3?rlkey=sw2rfj7jiu72cutml67d10vqs&dl=1",
        trackTime: "59:40",
        promo: "../image/radio/ripchord.jpg",
        promoCategory: 1
      }
    ]
}